import { React, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Компоненты пользовательского интерфейса
import '../../styles/AddKuobz.css';
import CustomButton from '../CustomElements/CustomButton';
import Input from '../CustomElements/Input';
import FormContainer from '../CustomElements/FormContainer';
import PhoneInput from '../CustomElements/PhoneInput';
// Кастомные хуки
import { useButtonValidation } from '../../customHook/useButtonValidation';
// Утилиты
import { handleUniversalChange } from '../../utils/formUtils';
import { isValidDeviceID } from '../../utils/isValidDeviceID';
import { checkValueLength } from '../../utils/checkValueLength';
import { convertStringValuesToNumbers } from '../../utils/convertStringValuesToNumbers';
import { removeEmptyStrings } from '../../utils/removeEmptyStrings';
// Действия Redux
import { addError } from '../../redux/actions//error.action';
import { load, remove } from '../../redux/actions/loader.action';
import { newKuobzFromServer } from '../../redux/actions/kuobz.action';

// Компонент для добавления нового КУОБЗ

function AddKuobz({ closeModal, t }) {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();

  // Получаем данные о процессе
  const loader = useSelector((state) => state.loader);

  // состояние для отображения страницы подтверждения
  const [addSuccess, setAddSuccess] = useState(false);

  // состояние для необязательных полей
  const [optionalFields, setOptionalFields] = useState([
    'sim1Number',
    'sim2Number',
    'sim2Imei',
    'sim1Serial',
    'sim2Serial',
  ]);

  // Состояние для формы
  const [formData, setFormData] = useState({
    id: '',
    sim1Number: '',
    sim2Number: '',
    sim1Imei: '',
    sim2Imei: '',
    sim1Serial: '',
    sim2Serial: '',
  });

  const isButtonDisabled = useButtonValidation(formData, optionalFields);

  // Обработчик отправки формы
  const handlerSubmit = (event) => {
    event.preventDefault();
    // Проверяем валидность id
    if (!isValidDeviceID(formData.id, 3)) {
      return dispatch(addError({ error: 'Указан невалидный ID устройства' }));
    }
    // Проверяем валидность imei1
    if (formData?.sim1Imei && !checkValueLength(formData?.sim1Imei, 15)) {
      return dispatch(
        addError({ error: t?.errorInvalidImei1 || 'Указан невалидный imei1, значение должно содержать 15 символов' })
      );
    }
    // Проверяем валидность sim2Imei
    if (formData?.sim2Imei && !checkValueLength(formData?.sim2Imei, 15)) {
      return dispatch(
        addError({ error: t?.errorInvalidImei2 || 'Указан невалидный imei2, значение должно содержать 15 символов' })
      );
    }
    // Проверяем валидность sim1Number
    if (
      formData?.sim1Serial &&
      !checkValueLength(formData?.sim1Serial, 20) &&
      !checkValueLength(formData?.sim1Serial, 18)
    ) {
      return dispatch(
        addError({
          error: t?.errorInvalidSim1num || 'Указан невалидный sim1num, значение должно содержать 18 или 20 символов',
        })
      );
    }
    // Проверяем валидность sim2num
    if (
      formData?.sim2Serial &&
      !checkValueLength(formData?.sim2Serial, 20) &&
      !checkValueLength(formData?.sim2Serial, 18)
    ) {
      return dispatch(
        addError({
          error: t?.errorInvalidSim2num || 'Указан невалидный sim2num, значение должно содержать 18 или 20 символов',
        })
      );
    }

    // Если все проверки пройдены успешно, переходим к отправке данных
    // Переводим в состояние загрузки
    dispatch(load());
    // Удаляем все пустые строки из объекта формы
    const cleanedData = removeEmptyStrings(formData);
    // Преобразуем нужные строковые поля в числа
    const payload = convertStringValuesToNumbers(cleanedData, ['id']);
    // Отправляем данные на сервер через Redux
    dispatch(newKuobzFromServer(payload));
  };

  //отслеживаем выполнение запроса
  useEffect(() => {
    // Если нет ошибок, закрываем модальное окно
    if (!loader?.isLoading && loader?.isSuccess) {
      setAddSuccess(true);
    }
    // при закрытии компонента чистим стейт загрузки
    return () => {
      dispatch(remove());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loader?.isLoading, loader?.isSuccess]);

  // Закрывает модальное окно после успешного добавления нового устройства
  const handlerCloseModal = () => {
    closeModal();
    setAddSuccess(false);
  };

  useEffect(() => {
    if (formData.sim2Number) {
      setOptionalFields((prevState) => prevState.filter((item) => item !== 'sim2Imei'));
    }
  }, [formData.sim2Number]);

  return (
    <div className="add-kuobz">
      <div className="add-kuobz_container-title">
        <h3 className="add-kuobz_title">{t?.addKuobzTitle || 'ДОБАВЛЕНИЕ НОВОГО КУОБЗ'}</h3>
      </div>
      {addSuccess && (
        <div className="add-kuobz_container-success">
          <h5 className="add-kuobz_title-success">{t?.addKuobzSuccess || 'Новый КУОБЗ добавлен!'}</h5>
          <CustomButton
            width={'--sadr-font-size-420'}
            height="var(--sadr-font-size-60)"
            text={t?.backToList || 'К списку устройств'}
            disabled={isButtonDisabled}
            onClick={handlerCloseModal}
          />
        </div>
      )}
      {!addSuccess && (
        <FormContainer>
          <Input
            column="left"
            onChange={(event) => handleUniversalChange(formData, setFormData, event, null, null, null, null, null, 15)}
            name="sim1Imei"
            label={t?.labelImei1 || 'IMEI 1 *'}
            placeholder={t?.placeholderImei1 || 'Введите IMEI 1'}
            width="100%"
            height="var(--sadr-font-size-60)"
            mask="999999999999999"
          />
          <PhoneInput
            column="left"
            label={t?.labelSim1 || 'SIM1'}
            name="sim1Number"
            onChange={(event) => handleUniversalChange(formData, setFormData, event)}
            value={formData.sim1Number}
          />

          <Input
            column="left"
            onChange={(event) => handleUniversalChange(formData, setFormData, event)}
            name="sim1Serial"
            label={t?.labelSim1num || 'Номер SIM 1'}
            placeholder={t?.placeholderSim1num || 'Введите номер SIM 1'}
            width="100%"
            height="var(--sadr-font-size-60)"
            mask="99999999999999999999"
          />
          <Input
            column="right"
            onChange={(event) => handleUniversalChange(formData, setFormData, event)}
            name="sim2Imei"
            label={formData?.sim2Number ? t?.labelImei2Required || 'IMEI 2 *' : t?.labelImei2 || 'IMEI 2'}
            placeholder={t?.placeholderImei2 || 'Введите IMEI 2'}
            width="100%"
            height="var(--sadr-font-size-60)"
            mask="999999999999999"
          />
          <PhoneInput
            column="right"
            label={t?.labelSim2 || 'SIM2'}
            name="sim2Number"
            onChange={(event) => handleUniversalChange(formData, setFormData, event)}
            value={formData.sim2Number}
          />

          <Input
            column="right"
            onChange={(event) => handleUniversalChange(formData, setFormData, event)}
            name="sim2Serial"
            label={t?.labelSim2num || 'Номер SIM 2'}
            placeholder={t?.placeholderSim2num || 'Введите номер SIM 2'}
            width="100%"
            height="var(--sadr-font-size-60)"
            mask="99999999999999999999"
          />
          <Input
            column="right"
            onChange={(event) => handleUniversalChange(formData, setFormData, event, null, null, null, null, null, 6)}
            name="id"
            label={t?.kuobzIdLabel || 'ID КУОБЗ *'}
            placeholder={t?.kuobzIdPlaceholder || 'Введите ID КУОБЗ'}
            width="100%"
            height="var(--sadr-font-size-60)"
            mask="999999"
          />
          <CustomButton
            width="var(--sadr-font-size-420)"
            height="var(--sadr-font-size-60)"
            text={t?.addDeviceButton || 'Добавить устройство'}
            onClick={(event) => {
              handlerSubmit(event);
            }}
            disabled={isButtonDisabled}
            isButton
          />
        </FormContainer>
      )}
    </div>
  );
}

export default AddKuobz;
